module.exports = __webpack_public_path__ + "img/customer02.13d6017e.png";